<template>
  <div class="orderDetails" v-if="detailsData">
    <div>
      <RFQInfo @changeDetails="changeDetails" :detailsData="detailsData"/>
    </div>
    <div>
      <partInfo :detailsData="detailsData" @changeDetails="changeDetails" :partner="partner"/>
    </div>
    <div>
      <NDAdialog ref="NDAdialog" :id="detailsData.id" @changeDetails="changeDetails"></NDAdialog>
    </div>
    <div>
      <isSettled ref="isSettled"  @changeDetails="changeDetails" :salesInfoClient="salesInfoClient" :channel="detailsData.clientId" :showAgreementList="showAgreementList" :currentChannle="detailsData.clientId"></isSettled>
    </div>
    <div>
      <NDAUploadDialog v-model="uploadVisible" :id="detailsData.id" @changeDetails="changeDetails" v-if="uploadVisible"></NDAUploadDialog>
    </div>
    <div>
      <contactBuyDialog ref="contactBuy" :contactBuyData="contactBuyData"></contactBuyDialog>
    </div>
  </div>
</template>
<script>
import RFQInfo from '@/components/zhenyunOrder/RFQInfo.vue';
import partInfo from '@/components/zhenyunOrder/partInfo.vue';
import NDAdialog from '@/components/common/zhenyun/NDADialog.vue';
import NDAUploadDialog from '@/components/common/zhenyun/NDAUploadDialog.vue';
import isSettled from '@/components/common/zhenyun/isSettled.vue';
import contactBuyDialog from '@/components/common/zhenyun/contactBuyDialog.vue';
import { mapGetters } from 'vuex';
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
import { getZhenYunAgreementListApi } from '@/utils/api/zhenyun-agreement'
export default {
  mixins: [zhenyunOrderMinxis],
  props:{
    detailsData:{
      default:null
    },
    partner:{
      default:0
    }
  },
  components:{
    RFQInfo,partInfo,NDAdialog,isSettled,contactBuyDialog,
    NDAUploadDialog
  },
  computed: {
    ...mapGetters(['salesInfoGetter']),
  },
  data(){
    return{
      isCanQuoteData:{
        title:'您不符合采购设置的报价条件',
        helpText:'如需帮助，请联系你的客户经理',
      },
      quoteQuotaFullData:{
        title:'抱歉，报价名额已达采购商设置的上限',
        helpText:'如需帮助，请联系你的客户经理',
      },
      contactBuyData:this.isCanQuoteData,
      salesInfoClient:null,
      uploadVisible:false,
      agreementArray:[],
      showAgreementList:[]
    }
  },
  watch:{
    detailsData:{
      handler(newVal,oldVal){
        if(newVal){
          this.getClientContact(this.detailsData.clientId)
        }
      }
    }
  },
  methods:{
    changeDetails(fun,value){
      this[fun](value)
    },
    // 联系采购
    contactBuyer(value){
      console.log(value)
    },
    // 立即报价
    promptlyQuot(value){
      // 判断数据来源
      if(value==0){
        this.showAgreementList = this.agreementArray.filter(k=>k.channel==this.detailsData.clientId)
        this.$refs.isSettled.settledVisible=true
      }
      // 是否一级保密协议 1
      if(value==1){
        this.$refs.NDAdialog.NDAVisible=true
      }
      
      if(value==2){
        // 能否报价 2
        this.contactBuyData=this.isCanQuoteData
        this.$refs.contactBuy.contactBuyVisible=true
      }
      if(value==3){
        // 是否满额
        this.contactBuyData=this.quoteQuotaFullData
        this.$refs.contactBuy.contactBuyVisible=true
        
      }
      if(value=='nda2'){
        this.uploadVisible=true
      }
    },
    // 接受协议
    accept(value){
      this.$refs.NDAdialog.NDAVisible=true
    },
    // 同意协议或入驻成功后调用接口
    agree(value){
      this.$emit('getDetail',this.detailsData.id)
    },
    // 查看图纸
    viewDrawing(value){
      if(value==0){
        this.showAgreementList = this.agreementArray.filter(k=>k.channel==this.detailsData.clientId)
        this.$refs.isSettled.settledVisible=true
      }
      if(value==1){
        this.$refs.NDAdialog.NDAVisible=true
      }
      if(value==2){
        // 能否报价 2
        this.contactBuyData=this.isCanQuoteData
        this.$refs.contactBuy.contactBuyVisible=true
      }
      if(value==3){
        // 是否满额
        this.contactBuyData=this.quoteQuotaFullData
        this.$refs.contactBuy.contactBuyVisible=true
        
      }
      if(value=='nda2'){
        this.uploadVisible=true
      }
    },
    fetchAgreementList(){
      getZhenYunAgreementListApi().then(res=>{
        const {rspResult,rspListData:{list}} = res
        if(rspResult.bizCode==200){
          this.agreementArray=list
        }
      })
    }
  },
  
  mounted(){
    this.fetchAgreementList()
  }
};
</script>
<style lang="scss" scoped>
.orderDetails{
    // margin-top: 12px;
    background: #FFF;
    padding: 16px;
}
</style>